import ReactFullpage from "@fullpage/react-fullpage";
import React, { useRef, useEffect } from "react";
import AppLayout from '../components/AppLayout';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import portfolioData from '../portfoli.json';
import PortfolioBox from "../components/portfolio/PortfolioBox";

import { useDispatch, useSelector } from "react-redux";
import { setHeaderTheme } from '../store/headerSlice';
import { useLocation } from 'react-router-dom';

const Portfolio = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const fullpageRef = useRef(null);
  const anchors = portfolioData.porfolio.map(item => item.navigator);

  const fullpageOptions = {
    scrollingSpeed: 1000,
    anchors: anchors,
  };

  useEffect(() => {
    const newTheme = location.hash === "#howcare" || location.hash === "#drcoach" || location.hash === "#fantoo" || location.hash === "#codebook" ? "black" : "white";
    dispatch(setHeaderTheme(newTheme));
  }, [dispatch, location.hash]);

  return (
    <HelmetProvider>
      <AppLayout>
        <Helmet>
          <title>TOPPING - Portfolio</title>
          <meta name="description" content="토핑의 포트폴리오를 확인해보세요. 웹/앱/플랫폼 서비스 개발 전문 회사 토핑의 다양한 프로젝트를 소개합니다." />
          <meta name="keywords" content="TOPPING, 토핑, 포트폴리오, 웹개발, 앱개발, 플랫폼개발" />
          <meta property="og:title" content="TOPPING - Portfolio" />
          <meta property="og:description" content="토핑의 포트폴리오를 확인해보세요. 웹/앱/플랫폼 서비스 개발 전문 회사 토핑의 다양한 프로젝트를 소개합니다." />
          <meta property="og:type" content="website" />
        </Helmet>
        <ReactFullpage
          ref={fullpageRef}
          {...fullpageOptions}
          render={({ state, fullpageApi }) => (
            <ReactFullpage.Wrapper>
              {portfolioData.porfolio.map((item, index) => (
                <PortfolioBox item={item} key={item.id} className={item.title} />
              ))}
            </ReactFullpage.Wrapper>
          )}
        >
        </ReactFullpage>
      </AppLayout>
    </HelmetProvider>
  );
};

export default Portfolio;